<template>
  <div>
    <v-container class="mb-15 page__wrapper" style="position: relative">
      <v-btn
        icon
        style="position: absolute; top: 10px; left: 10px"
        @click="back"
      >
        <v-icon color="primary" style="font-size: 45px"
          >mdi-chevron-left</v-icon
        >
      </v-btn>
      <validation-observer ref="observer" v-slot="{ invalid }">
        <form @submit.prevent="goToPageEditBarLabelPage">
          <h3 class="mt-5 mb-5">
            {{ $t('Step') }} 4 : {{ $t('Choose actions') }}
            <!-- <v-btn small outlined class="btn-custom right"><span>Preview</span> </v-btn> -->
          </h3>
          <div style="text-align: -webkit-center">
            <div ref="setWidth" class="setKonvaWidth"></div>
            <div
              id="template4Set"
              style="
                box-sizing: border-box;
                -moz-box-sizing: border-box;
                -webkit-box-sizing: border-box;
              "
            >
              <template v-if="!loadingImg">
                <v-stage
                  ref="stage"
                  class="mt-5"
                  :config="{
                    width: templateSelect.content_json.size.width * scaleState,
                    height:
                      templateSelect.content_json.size.height * scaleState,
                    scale: {
                      x: scaleState,
                      y: scaleState
                    }
                  }"
                  style="text-align: -webkit-center"
                >
                  <v-layer>
                    <v-image
                      :config="{
                        image: image,
                        width: templateSelect.content_json.size.width,
                        height: templateSelect.content_json.size.height
                      }"
                    />

                    <template
                      v-for="(area, index) in templateSelectData.content_json
                        .areas"
                    >
                      <v-rect
                        :key="index"
                        :config="{
                          width: area.bounds.width,
                          height: area.bounds.height,
                          x: area.bounds.x,
                          y: area.bounds.y,
                          stroke:
                            selectAction === index ? '#ff706b' : '#FFFFFF',
                          strokeWidth:
                            selectAction === index ? 10 : parseInt(lineReg),
                          fill:
                            selectAction === index || selectAction === null
                              ? undefined
                              : 'black',
                          opacity:
                            selectAction === index || selectAction === null
                              ? undefined
                              : 0.5
                        }"
                        @click="editBound(index)"
                        @mouseenter="handleMouseEnter"
                        @mouseleave="handleMouseLeave"
                      ></v-rect>
                      <!-- <v-text
                      :key="`text___${index}`"
                      :config="{
                        text: `ภาพที่ ${index + 1}`,
                        x: area.bounds.x * scaleState,
                        y: area.bounds.y * scaleState + 15,
                        width: area.bounds.width * scaleState,
                        align: 'center',
                        fill: 'var(--v-primary-lighten2)',
                      }"
                    /> -->
                    </template>
                  </v-layer>
                </v-stage>
              </template>
              <div class="pl-4 keyboard py-2">
                <v-icon style="font-size: 35px; float: left" color="#ffffff"
                  >mdi-keyboard</v-icon
                >
                <div
                  class="pa-1 text-center"
                  style="padding-right: 40px !important; min-height: 32px"
                >
                  <span
                    >{{ templateSelect.content_json.chatBarText }}
                    <v-icon color="#ffffff"> mdi-menu-down </v-icon>
                  </span>
                </div>
              </div>
            </div>
          </div>
          <template v-if="!loadingImg">
            <div class="text-center mt-3">
              <v-btn-toggle v-model="lineReg">
                <v-btn style="text-transform: none !important" value="1">
                  {{ $t('Show line') }}
                </v-btn>
                <v-btn style="text-transform: none !important" value="0">
                  {{ $t('Hide line') }}
                </v-btn>
              </v-btn-toggle>
            </div>
            <!-- <preview-template></preview-template> -->
            <v-card class="mt-10 r0">
              <template
                v-for="(area, index) in templateSelectData.content_json.areas"
              >
                <v-card-text
                  :key="index"
                  class="pa-7 pa-md-10"
                  :style="
                    selectAction === index
                      ? 'background: var(--primary-color-lighten); border-left: 8px solid var(--primary-color); border-radius: 8px;'
                      : 'none'
                  "
                >
                  <v-row @click="editBound(index)">
                    <v-col cols="4" class="pt-3">
                      <span :id="`select${index}`" :ref="`select${index}`">
                        {{ $t('Picture') }} {{ index + 1 }} :<span
                          class="color-red"
                          >*</span
                        ></span
                      >
                    </v-col>
                    <v-col cols="8">
                      <validation-provider
                        v-slot="{ errors }"
                        :name="$t('Picture') + (index + 1)"
                        rules="required"
                        immediate
                      >
                        <v-select
                          v-model="area.action.type"
                          :class="area.action.type"
                          class="bg"
                          item-text="name"
                          :items="items"
                          item-value="value"
                          :error-messages="errors"
                          outlined
                          dense
                        >
                          <template #prepend>
                            <!-- <v-tooltip bottom v-if="area.action.type === 'uri'">
                            <template v-slot:activator="{ on, attrs }"> -->
                            <template v-if="area.action.type === 'uri'">
                              <modal-help>
                                <div slot="icon">
                                  <v-icon color="primary" dark>
                                    mdi-link-variant
                                  </v-icon>
                                </div>
                                <div slot="body">
                                  <div style="padding: 15px">
                                    <p class="strong">{{ $t('Link URL') }}</p>
                                    <ul>
                                      <li>
                                        {{
                                          $t(
                                            'When the customer clicks Link URL, they will go to the website page that they want to visit. Conditions The prefix must be https:// only. For example https://www.zwiz.ai/ etc.'
                                          )
                                        }}
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </modal-help>
                            </template>
                            <!-- </template>
                            <span
                              >{{
                                $t(
                                  "When the customer clicks Link URL, they will go to the website page that they want to visit. Conditions The prefix must be https:// only. For example https://www.zwiz.ai/ etc."
                                )
                              }}
                            </span>
                          </v-tooltip> -->
                            <!-- <v-tooltip bottom v-if="area.action.type === 'postback'">
                            <template v-slot:activator="{ on, attrs }"> -->
                            <!-- <v-icon color="primary" dark v-if="area.action.type === 'postback'">
                            mdi-text-shadow
                          </v-icon> -->
                            <template
                              v-if="
                                area.action.type === 'postback' ||
                                area.action.type === 'message'
                              "
                            >
                              <modal-help>
                                <div slot="icon">
                                  <v-icon color="primary" dark>
                                    mdi-text-shadow
                                  </v-icon>
                                </div>
                                <div slot="body">
                                  <div style="padding: 15px">
                                    <p class="strong">{{ $t('Text') }}</p>
                                    <ul>
                                      <li>
                                        {{
                                          $t(
                                            "When the customer presses the picture. The bot will respond in a text message or reply as a keyword that is set up for the conversation in the ZWIZ.ai Chatbot system so that the bot can continue replying to that conversation. For example, when a customer clicks an image that we set action 'Text', the system will send back to the word 'Price' in the chat and catch the keywords that we set in the system. It will reply as the next conversation we set up."
                                          )
                                        }}
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </modal-help>
                            </template>
                            <!-- </template>
                            <span>{{
                              $t(
                                "When the customer presses the picture. The bot will respond in a text message or reply as a keyword that is set up for the conversation in the ZWIZ.ai Chatbot system so that the bot can continue replying to that conversation. For example, when a customer clicks an image that we set action 'Text', the system will send back to the word 'Price' in the chat and catch the keywords that we set in the system. It will reply as the next conversation we set up."
                              )
                            }}</span>
                          </v-tooltip> -->
                            <!-- <v-tooltip bottom v-if="area.action.type === 'phone_number'">
                            <template v-slot:activator="{ on, attrs }"> -->
                            <!-- <v-icon color="primary" dark v-if="area.action.type === 'phone_number'">
                            mdi-phone
                          </v-icon> -->
                            <template
                              v-if="area.action.type === 'phone_number'"
                            >
                              <modal-help>
                                <div slot="icon">
                                  <v-icon color="primary" dark>
                                    mdi-phone
                                  </v-icon>
                                </div>
                                <div slot="body">
                                  <div style="padding: 15px">
                                    <p class="strong">
                                      {{ $t('Phone Number') }}
                                    </p>
                                    <ul>
                                      <li>
                                        {{
                                          $t(
                                            'Enter a phone number to make it easier for customers to contact us. But there is a condition that must be entered as +66 instead of the zero of Thailand, for example, customer number 0812345678 enter as +6612345678.'
                                          )
                                        }}
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </modal-help>
                            </template>
                            <!-- </template>
                            <span>{{
                              $t(
                                "Enter a phone number to make it easier for customers to contact us. But there is a condition that must be entered as +66 instead of the zero of Thailand, for example, customer number 0812345678 enter as +6612345678."
                              )
                            }}</span>
                          </v-tooltip> -->
                            <!-- <v-tooltip bottom v-if="area.action.type === 'richmenuswitch'">
                            <template v-slot:activator="{ on, attrs }"> -->
                            <!-- <v-icon color="primary" dark v-if="area.action.type === 'richmenuswitch'">
                            mdi-view-list-outline
                          </v-icon> -->
                            <template
                              v-if="area.action.type === 'richmenuswitch'"
                            >
                              <modal-help>
                                <div slot="icon">
                                  <v-icon color="primary" dark>
                                    mdi-view-list-outline
                                  </v-icon>
                                </div>
                                <div slot="body">
                                  <div style="padding: 15px">
                                    <p class="strong">
                                      {{ $t('Next rich menu') }}
                                    </p>
                                    <ul>
                                      <li>
                                        {{
                                          $t(
                                            'You can press one Rich menu and connect to another Rich menu. For example, we have 4 Rich Menus that can make all 4 Rich menus linked and connected in the same LineOA.'
                                          )
                                        }}
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </modal-help>
                            </template>
                            <!-- </template>
                            <span>{{
                              $t(
                                "You can press one Rich menu and connect to another Rich menu. For example, we have 4 Rich Menus that can make all 4 Rich menus linked and connected in the same LineOA."
                              )
                            }}</span>
                          </v-tooltip> -->
                            <!-- <v-tooltip bottom v-if="area.action.type === 'none'">
                            <template v-slot:activator="{ on, attrs }"> -->
                            <!-- <v-icon color="primary" dark v-if="area.action.type === 'none'">
                            mdi-cancel
                          </v-icon> -->
                            <template v-if="area.action.type === 'none'">
                              <modal-help>
                                <div slot="icon">
                                  <v-icon color="primary" dark>
                                    mdi-cancel
                                  </v-icon>
                                </div>
                                <div slot="body">
                                  <div style="padding: 15px">
                                    <p class="strong">{{ $t('No action') }}</p>
                                    <ul>
                                      <li>
                                        {{
                                          $t(
                                            'If the customer presses it, it will not respond to anything.'
                                          )
                                        }}
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </modal-help>
                            </template>
                            <!-- </template>
                            <span>{{
                              $t("If the customer presses it, it will not respond to anything.")
                            }}</span>
                          </v-tooltip> -->
                          </template>
                        </v-select>
                      </validation-provider>
                    </v-col>
                  </v-row>
                  <template v-if="area.action.type === 'uri'">
                    <validation-provider
                      v-slot="{ errors }"
                      :name="$t('Link URL')"
                      :rules="{ isUrl: true, required: true, max: 600 }"
                      immediate
                    >
                      <v-text-field
                        v-model="area.action.uri"
                        :placeholder="$t('Link URL')"
                        :error-messages="errors"
                        outlined
                        dense
                        :rules="[
                          (v) =>
                            (v || '').length <= 600 ||
                            $t('Link URL must be 600 characters or less')
                        ]"
                      ></v-text-field>
                    </validation-provider>
                  </template>
                  <template v-if="area.action.type === 'postback'">
                    <validation-provider
                      v-slot="{ errors }"
                      :name="$t('Text')"
                      rules="required"
                      immediate
                    >
                      <v-text-field
                        v-model="area.action.displayText"
                        :placeholder="$t('Text')"
                        :error-messages="errors"
                        outlined
                        dense
                        @input="area.action.data = area.action.displayText"
                      ></v-text-field>
                    </validation-provider>
                    <!-- <div class="text-center">
                      <v-btn
                        x-small
                        outlined
                        color="primary"
                        rounded
                        class="mb-2"
                        @click="toggleAdvance(index)"
                      >
                        Advance
                        <v-icon x-small>{{
                          showAdvance[index] ? "mdi-chevron-down" : "mdi-chevron-up"
                        }}</v-icon>
                      </v-btn>
                    </div> -->
                    <!-- <div v-show="showAdvance[index]">
                      <validation-provider
                        v-slot="{ errors }"
                        :name="$t('Type Action')"
                        rules="required"
                      >
                        <v-text-field
                          v-model="area.action.data"
                          :placeholder="$t('Type Action')"
                          :error-messages="errors"
                          outlined
                          dense
                        ></v-text-field>
                      </validation-provider>
                    </div> -->
                  </template>
                  <template v-if="area.action.type === 'message'">
                    <validation-provider
                      v-slot="{ errors }"
                      :name="$t('Text')"
                      rules="required|max:300"
                      immediate
                    >
                      <v-text-field
                        v-model="area.action.text"
                        :placeholder="$t('Text')"
                        :error-messages="errors"
                        outlined
                        dense
                        maxlength="300"
                      ></v-text-field>
                    </validation-provider>
                  </template>
                  <template v-if="area.action.type === 'phone_number'">
                    <validation-provider
                      v-slot="{ errors }"
                      :name="$t('Phone Number')"
                      :rules="{
                        required: true,
                        regex:
                          /^[+]{1}[1-9]{1}[0-9]{0,2}[1-9]{1}[0-9]{7,8}$|^[0-9]{3,4}$/
                      }"
                      immediate
                    >
                      <!-- <small class="caption grey--text">Ex. +66812345678 or 123 or 1678</small> -->
                      <v-text-field
                        v-model="area.action.phone_number"
                        type="tel"
                        :placeholder="`${$t('Ex.')} +66812345678 ${$t(
                          'or'
                        )} 123 ${$t('or')} 1678`"
                        :error-messages="errors"
                        outlined
                        dense
                      ></v-text-field>
                    </validation-provider>
                  </template>
                  <template v-if="area.action.type === 'richmenuswitch'">
                    <validation-provider
                      v-slot="{ errors }"
                      name="Richmenu"
                      rules="required"
                      immediate
                    >
                      <v-select
                        v-model="area.action.data"
                        :error-messages="errors"
                        :items="lineRichmenuOptions"
                        outlined
                        dense
                      >
                        <v-text-field
                          v-model="area.action.text"
                          type="hidden"
                        ></v-text-field>
                        <!-- <template v-slot:append-outer>
                    <v-btn
                      small
                      style="min-width: 38px; bottom: 7px;"
                      outlined
                      class="btn-custom pa-0 "
                      ><v-icon>mdi-plus-thick</v-icon>
                    </v-btn>
                  </template> -->
                      </v-select>
                    </validation-provider>
                  </template>
                </v-card-text>
                <v-divider
                  v-if="
                    index != templateSelectData.content_json.areas.length - 1
                  "
                  :key="`divider_${index}`"
                />
              </template>
            </v-card>
            <!-- <template>
            <div class="btn-sticky mt-8 pr-pl-12">
              <v-btn outlined @click="back" class="btn-back-richmenu w45 br-7">Back</v-btn>
              <v-btn
                outlined
                class="btn-custom btn-next-richmenu w45 right"
                :disabled="invalid"
                type="submit"
                ><span>Next</span>
              </v-btn>
            </div>
          </template> -->
            <template>
              <v-card class="command-bar">
                <div class="btn-sticky mt-5 pr-pl-12 sticky-left">
                  <v-btn
                    outlined
                    class="btn-custom right btn-custom-outline-color"
                    :href="how_to_use_blog"
                    target="blank"
                    depressed
                    rounded
                  >
                    <v-icon>mdi-help-circle</v-icon
                    ><span class="ml-1"> {{ $t('How to use') }}</span>
                  </v-btn>
                </div>
                <div class="btn-sticky mt-5 pr-pl-12 sticky-right">
                  <v-btn
                    outlined
                    class="btn-custom btn-next-richmenu right"
                    style="width: 180px"
                    :disabled="invalid"
                    type="submit"
                    ><span>{{ $t('save_and_next') }}</span>
                  </v-btn>
                </div>
              </v-card>
            </template>
          </template>
        </form>
      </validation-observer>
    </v-container>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ModalHelp from '../ModalHelp.vue'
import configUrl from '@/config'
// import queryString from 'query-string'
// import PreviewTemplate from "./PreviewTemplate";
export default {
  components: { ModalHelp },
  props: ['value', 'imageToSubmit'],
  data() {
    return {
      lineReg: '1',
      showAdvance: [],
      loadingImg: true,
      boundsInfo: undefined,
      cacheBoundsInfo: '',
      image: null,
      items: [
        { name: 'Link URL', value: 'uri' },
        // { name: "Text", value: "postback" },
        { name: 'Text', value: 'message' },
        { name: 'Next rich menu', value: 'richmenuswitch' },
        { name: 'Phone number', value: 'phone_number' },
        { name: 'No action', value: 'none' }
      ],
      selectAction: null,
      maxWidth: 0,
      templateSelectData: [],
      how_to_use_blog: configUrl.how_to_use_blog
    }
  },
  async created() {
    // Promise.all(
    //   this.imageSelect.map(async (item) => {
    //     return await this.loadingImage(item);
    //   })
    // ).then((result) => {
    //   this.image = result;
    //   if (this.image.length !== 0) {
    //     this.loadingImg = true;
    //   }
    // });
  },
  computed: {
    ...mapGetters({
      templateSelect: 'lineRichmenuManager/getTemplateSelect',
      lineRichmenu: 'lineRichmenuManager/getLineRichMenu',
      getIdTemplate: 'lineRichmenuManager/getIdTemplate'
    }),
    scaleState() {
      return this.maxWidth / this.templateSelect.content_json.size.width
    },
    lineRichmenuOptions() {
      try {
        return this.lineRichmenu
          .map((el) => {
            if (el.package_id && el.id != this.getIdTemplate) {
              return {
                text: el.name,
                value: `nextrichmenu:${this.getIdTemplate}|${el.id}`
              }
            } else {
              return null
            }
          })
          .filter((el) => {
            return el != null
          })
      } catch (error) {
        return []
      }
    }
  },
  async mounted() {
    this.loadingImg = true
    this.templateSelect.content_json.areas.map((item) => {
      if (item.action.type === 'uri') {
        if (typeof item.action.uri !== 'undefined') {
          if (item.action.uri.split(':')[0] === 'tel') {
            item.action.type = 'phone_number'
            item.action.phone_number = item.action.uri.split(':')[1]
          } else {
            //
            if (item.action.uri.includes('link.zwiz.ai')) {
              var urlParams = new URLSearchParams(item.action.uri)
              if (urlParams.has('rurl')) {
                item.action.uri = urlParams.get('rurl')
              }
            }
          }
        }
      }
      if (item.action.type === 'postback') {
        item.action.type = 'message'
        if (item.action.data.indexOf('nextrichmenu:') != -1) {
          item.action.type = 'richmenuswitch'
        } else if (item.action.data.indexOf('pb=') != -1) {
          try {
            var data = item.action.data.split('|')
            if (data.length >= 2) {
              item.action.data = data[1]
            }
          } catch (error) {
            //
          }
        }
      }
      this.templateSelectData = this.templateSelect
    })
    this.image = await this.loadImage(this.templateSelectData.image_url)
    await this.$nextTick()
    this.loadingImg = false
    this.maxWidth = this.$refs.setWidth.clientWidth
    // this.$store.dispatch("lineRichmenuManager/getLineRichMenu");
    // this.loadingImg = false;
  },
  methods: {
    toggleAdvance(index) {
      this.$set(this.showAdvance, index, !this.showAdvance[index])
    },
    // toggleShowLine(lineReg) {},
    handleMouseEnter(e) {
      const stage = e.target.getStage()
      stage.container().style.cursor = 'pointer'
    },
    handleMouseLeave(e) {
      const stage = e.target.getStage()
      stage.container().style.cursor = 'default'
    },
    // loadingImage(img) {
    //   const image = new window.Image();
    //   image.src = img;
    //   image.onload = () => {
    //     // set image only when it is loaded
    //     image.crossOrigin = "Anonymous";
    //     return image;
    //   };
    //   return image;
    // },
    editBound(index) {
      this.selectAction = index
      this.goto(`select${index}`)
      // this.boundsInfo = area.action;
      // this.cacheBoundsInfo = JSON.stringify(area.action);
      // this.indexBoundsInfo = index;
      // this.showModal = true;
    },
    goto(refName) {
      this.$vuetify.goTo(document.querySelector(`#${refName}`), {
        duration: 500,
        offset: 0,
        easing: 'easeInOutCubic'
      })
    },
    // onClose() {
    //   this.boundsInfo = this.cacheBoundsInfo;
    //   console.log(this.boundsInfo);
    //   this.showModal = false;
    // },
    async goToPageEditBarLabelPage() {
      this.templateSelectData.id =
        this.$store.state.lineRichmenuManager.idTemplate
      var prefix = window.location.hostname == 'app.zwiz.ai' ? 'z_' : ''
      this.$gtag.event('event', {
        event_category: prefix + 'Step 4 Choose actions next'
        // event_label: bot.pagename + utm,
      })
      this.templateSelectData.content_json.areas.map((item, i) => {
        if (item.action.type === 'phone_number') {
          item.action.type = 'uri'
          this.$set(
            this.templateSelectData.content_json.areas[i].action,
            'uri',
            'tel:' + item.action['phone_number']
          )
          delete this.templateSelectData.content_json.areas[i].action
            .phone_number
        } else if (item.action.type === 'uri') {
          // let uri = encodeURIComponent(item.action.uri);
          let uri = item.action.uri
          if (
            uri.includes('https://line.me/R/') ||
            uri.includes('https://liff.line.me/') ||
            uri.includes('https%3A%2F%2Fline.me%2FR%2F')
          ) {
            this.$set(
              this.templateSelectData.content_json.areas[i].action,
              'uri',
              `${uri}`
            )
          } else {
            this.$set(
              this.templateSelectData.content_json.areas[i].action,
              'uri',
              `http://link.zwiz.ai/LineRichmenuStat?rm=${this.templateSelectData.id}&rurl=${uri}`
            )
          }
        } else if (item.action.type === 'richmenuswitch') {
          item.action.type = 'richmenuswitch'
          try {
            let target = item.action.data.split('|')
            if (target.length > 0) {
              item.action.richMenuAliasId = 'zwizai-' + target[1]
            }
          } catch (error) {
            //
          }
        } else if (item.action.type === 'postback') {
          if (
            this.templateSelectData.content_json.areas[i].action.displayText
          ) {
            delete this.templateSelectData.content_json.areas[i].action
              .displayText
          }
          if (this.templateSelectData.content_json.areas[i].action.data) {
            delete this.templateSelectData.content_json.areas[i].action.data
          }
          item.action.type = 'message'
          this.$set(
            this.templateSelectData.content_json.areas[i].action,
            'displayText',
            `${item.action.displayText}`
          )
        } else if (item.action.type === 'message') {
          if (this.templateSelectData.content_json.areas[i].action.data) {
            delete this.templateSelectData.content_json.areas[i].action.data
          }
          this.$set(
            this.templateSelectData.content_json.areas[i].action,
            'text',
            `${item.action.text}`
          )
        }
      })
      this.$store.dispatch('setOverlay', true)
      var res = await this.$store.dispatch(
        'lineRichmenuManager/putTemplateSelect',
        this.templateSelectData
      )
      if (res && !res._isError) {
        this.$store.dispatch('setOverlay', false)
        this.$emit('goToPage', 6)
      } else {
        this.$store.dispatch('setOverlay', false)

        let title = 'Error'
        let text = `something went wrong, please try again.`

        if (res && res._isError && res.error) {
          const errData = res.error
          if (errData.message && errData.message.includes('error(s)')) {
            let hasUriError = false
            if (errData.details && errData.details.length > 0) {
              errData.details.forEach(detail => {
                if (detail.message.includes('invalid uri')) {
                  hasUriError = true
                }
              })
            }
            if (hasUriError) {
              title = this.$t('Error_With_Colon')
              text = this.$t('invalid_url_message')
            }
          }
        }

        this.$notify({
          group: 'foo',
          type: 'error',
          title: title,
          text: text
        })
      }
    },
    // mergeImage() {
    //   var vm = this;
    //   vm.$refs.stage.getStage().toImage({
    //     callback: function(img) {
    //       console.log(img);
    //       vm.$emit("imageToSubmit", img.src);
    //     },
    //     mimeType: "image/jpeg",
    //   });
    // },
    back() {
      this.$emit('goToPage', 3)
    }
  }
}
</script>

<style lang="scss" scoped>
.center {
  text-align-last: center;
  input {
    text-align: center;
  }
}
</style>
